
const Uploading = () => {
  return <div className="bg-blue-100 text-blue-800 w-full mb-4 p-2 rounded flex items-center justify-center">
           <div className="w-full h-2 bg-blue-200 rounded overflow-hidden">
            <div className="h-2 bg-blue-600 animate-progress-bar" style={{width: '100%'}}></div>
           </div>
           <span className="ml-3 text-blue-700 font-medium">Uploading...</span>
        </div>
} 
export default Uploading;